
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/product/[handle]",
      function () {
        return require("private-next-pages/[locale]/product/[handle]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/product/[handle]"])
      });
    }
  